import { WhiteSection } from 'components/base/layout-components';
import {
  StyledCategoriesList,
  StyledListWrapper,
  StyledSubHeader
} from './CategoriesList.style';
import CategoryItem from './CategoryItem';
import { StyledWidgetHeader } from '../CategoriesWidget.style';
import LoadingCategories from './LoadingCategories';

const CategoriesList = ({
  categories,
  selectedCategory,
  onClick,
  isLoading
}) => {
  return (
    <StyledCategoriesList>
      <WhiteSection>
        <StyledWidgetHeader>Investment Profile</StyledWidgetHeader>
        <StyledSubHeader>
          Assess your investments in research and development, new product
          development, infrastructure, and other projects that support your
          organization's New Value.
        </StyledSubHeader>

        <StyledListWrapper data-cy='styled-list-wrapper'>
          {isLoading ? (
            <LoadingCategories />
          ) : (
            categories.map((category, idx) => {
              const isSelected = category?.name === selectedCategory?.name;
              const isFirst = idx === 0;
              return (
                <CategoryItem
                  key={idx}
                  category={category}
                  isSelected={isSelected}
                  onClick={onClick}
                  {...(isFirst && { innerText: 'Benchmark' })}
                />
              );
            })
          )}
        </StyledListWrapper>
      </WhiteSection>
    </StyledCategoriesList>
  );
};

export default CategoriesList;
